<script lang="ts">
  import {ValidationMessage} from '@felte/reporter-svelte';
  import {formControlTvProps} from '.';
  import {cn} from 'Catalyst/cn';
  export let forName: string;
  export let helperText: string = '';

  $: formControlTvSlots = formControlTvProps();
  $: klass = $$restProps.class;
</script>

<div
  class={cn(formControlTvSlots.base(), klass)}
  data-testid="form-control-base"
>
  <slot />
  <ValidationMessage for={forName} let:messages={message}>
    <div class={formControlTvSlots.invalidText()}>{message}</div>
    <div
      slot="placeholder"
      class:hidden={!helperText}
      class={formControlTvSlots.helperTextWrapper()}
    >
      <span class={formControlTvSlots.helperText()}>{helperText}</span>
    </div>
  </ValidationMessage>
</div>
